import React from "react";

/**
 * WizardSteps - Displays horizontal step progress indicator
 * Uses rectangular button design with color coding
 */
const WizardSteps = ({ steps, currentStep, onStepClick, completedSteps = 0 }) => {
    return (
        <div className="wizard-steps">
            {steps.map((step, index) => {
                const isActive = step.id === currentStep;
                const isCompleted = step.id <= completedSteps;
                const isClickable = step.id <= currentStep; // Can only click current or previous steps
                
                // Determine step color class based on step number
                const stepColorClass = `step-${step.id}`;
                
                return (
                    <button
                        key={step.id}
                        className={`wizard-step-button ${stepColorClass} ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
                        onClick={() => isClickable && onStepClick(step.id)}
                        disabled={!isClickable}
                        type="button">
                        
                        <span className="wizard-step-number">
                            {isCompleted ? '✓' : step.id}
                        </span>
                        <span className="wizard-step-title">
                            {step.title}
                        </span>
                    </button>
                );
            })}
        </div>
    );
};

export default WizardSteps;